import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  form: FormGroup;
  submitted = false;
  fieldTextType: boolean = false;
  constructor(private formBuilder: FormBuilder, private router: Router,
    public auth: AuthService,) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group(
      {
        userName: [
          '', Validators.required],
        password: [
          '', Validators.required
        ],

      }
    );
  }
  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    this.auth.login(JSON.stringify(this.form.value, null, 2)).then((res) => {
     if(res['rol']=="ADM"){
      this.router.navigate(['/admin/userManagement']);
     }else{
      this.router.navigate(['/home/shipment']);
     }
     
    }).catch((err) => {

      console.error(err)
    })
    // this.router.navigate(['/home/shipment']);
  }

}
